import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { setConsentDecision, shouldShowConsentBanner } from "../../lib/consent";
import styles from "./CookieConsentBanner.module.css";

// The only non-essential storage runmark.app uses is for Firebase Analytics
// and Mixpanel (auth and language preference both live in
// localStorage/IndexedDB already, see
// lib/consent.ts). So this banner isn't gating access to anything -- the app
// works identically either way -- it's purely the opt-in for those analytics
// cookies. It's only shown where opt-in consent is required (EEA/UK/CH, see
// lib/consent.ts); everywhere else analytics is on by default. Declining
// keeps GA4 cookieless (Consent Mode) and Mixpanel off.
export default function CookieConsentBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(shouldShowConsentBanner());
  }, []);

  const handleAccept = () => {
    // No page-view backfill: GA4 already recorded this visit's page view as
    // a cookieless ping, so re-sending it would double-count.
    setConsentDecision("granted");
    setVisible(false);
  };

  const handleDecline = () => {
    setConsentDecision("denied");
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div className={styles.banner} role="dialog" aria-live="polite" aria-label={t("common.cookieConsent.title")}>
      <div className={styles.inner}>
        <p className={styles.text}>
          {t("common.cookieConsent.body")}{" "}
          <Link to="/privacy" className={styles.link}>
            {t("common.cookieConsent.learnMore")}
          </Link>
        </p>
        <div className={styles.actions}>
          <button type="button" className={styles.declineButton} onClick={handleDecline}>
            {t("common.cookieConsent.decline")}
          </button>
          <button type="button" className={styles.acceptButton} onClick={handleAccept}>
            {t("common.cookieConsent.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
